import { DisplayMode } from "@annunciate/core";
export const ROUTE_CONTENT_PREFIX = 'item';
export function resolveRouteFromItem(item) {
    const isCollection = item.__typename === 'Collection';
    const isRedirect = item.displayMode === DisplayMode.REDIRECT;
    if (isCollection && isRedirect) {
        throw new Error('Redirect modes have not yet been implemented for web.');
    }
    const basePath = window.location.pathname.startsWith('/discover') ? window.location.pathname : '/discover';
    const pathSegments = basePath.split('/');
    const isBaseAnItem = pathSegments.at(-2) === ROUTE_CONTENT_PREFIX;
    let newBasePath = basePath;
    if (isBaseAnItem) {
        newBasePath = pathSegments.slice(0, -2).join('/');
    }
    const slugPrefix = isCollection ? '' : `/${ROUTE_CONTENT_PREFIX}`;
    const segmentId = item.slug || item.id.toString();
    const append = `${slugPrefix}/${segmentId}`;
    const isCurrentAndNextTypeIdentical = (!isBaseAnItem && isCollection) ||
        (isBaseAnItem && !isCollection);
    if (isCollection) {
        const idx = pathSegments.indexOf(segmentId);
        if (idx >= 0) {
            return pathSegments.slice(0, idx + 1).join('/');
        }
        return `${newBasePath}${append}`;
    }
    if (basePath.endsWith(append) && isCurrentAndNextTypeIdentical) {
        return basePath;
    }
    else if (newBasePath.endsWith(append) && !isCurrentAndNextTypeIdentical) {
        return newBasePath;
    }
    else {
        return `${newBasePath}${append}`;
    }
}
//# sourceMappingURL=resolveRouteFromItem.js.map